import { get, filter } from 'lodash'
import { WEEK_DAYS_NUMBER } from '../../../constants';
import moment from 'moment';

export const disableWeekends = (date) => date.day() === WEEK_DAYS_NUMBER.Saturday || date.day() === WEEK_DAYS_NUMBER.Sunday;

export const getMaxDate = (startDate, notAvailablePeriods, maxStay) => {
  let dates = []

  if (startDate) {
    if (notAvailablePeriods) {
      const startD = get(
        filter(notAvailablePeriods, (period) => moment(period.endDate).isAfter(startDate)),
        '0.startDate',
      )
      if (typeof startD !== 'undefined') {
        dates.push(startD)
      }
    }

    if (maxStay) {
      dates.push(moment(startDate).add(maxStay, 'months'))
    }
  }

  return dates.length > 0 ? moment.min(dates).toISOString(true) : undefined
}

export const getFeatureFlagCheckout2025 = () => process.env.REACT_APP_FEATURE_FLAG_CHECKOUT_2025 === '1'